import React, { forwardRef } from "react";
import { Skeleton as ChakraSkeleton } from "@chakra-ui/react";

export const Skeleton = forwardRef(function Skeleton(props, ref) {
  const { variant = "pulse", ...rest } = props;
  return (
    <ChakraSkeleton
      ref={ref}
      {...rest}
      animation={
        variant === "pulse" ? "pulse" : variant === "shine" ? "shimmer" : "none"
      }
    />
  );
});
